import * as React from "react";
import styles from "./ExternalLink.module.scss";
import classnames from "classnames";
import { TurnrFontAwesomeIcon } from "../alerts/TurnrAlert";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";

export function ExternalLink(props) {
    const { href, style, text, className, onClick, showIcon = false } = props;
    return (
        <a onClick={onClick} href={href} style={style} target="_blank" className={classnames(className, styles["link"])} rel="noopener noreferrer">
            {text || href}{" "}
            {showIcon && (
                <div style={{ marginLeft: "10px" }}>
                    <TurnrFontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </div>
            )}
        </a>
    );
}
